import { createSlice } from "@reduxjs/toolkit";
import { getListZnsEvent } from "../../api/znsEvent/znsEvent";

// giá trị khởi tạo của state
const initialState = {
  listZnsEvents: [],
  isLoadZnsEvent: false,
  currentPage: 1,
  pageSize: 10,
  error: null,
  totalRecords: 0, // Tổng số bản ghi từ API  
};

const znsEventSlice = createSlice({
  name: "znsEvent", // tên phân biệt giữa các reduce
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setTotalRecords: (state, action) => {
      state.totalRecords = action.payload; // Sửa lỗi gán nhầm `pageSize`
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListZnsEvent.pending, (state) => {// api đnag pending chờ xử lý
        state.isLoadZnsEvent = true;
        state.error = null;
      })
      .addCase(getListZnsEvent.fulfilled, (state, action) => {// api trả về thành công thì trả ra
        state.isLoadZnsEvent = false;
        state.listZnsEvents = action.payload.data || [];

        state.isLoadZnsEvent = false;
        state.currentPage = action.payload.current_page; // Cập nhật trang hiện tại từ API
        state.pageSize = action.payload.per_page; // Cập nhật số bản ghi mỗi trang
        state.totalRecords = action.payload.total; // Cập nhật tổng số bản ghi
      })
      .addCase(getListZnsEvent.rejected, (state, action) => {// api trả về thất bại thì trả ra
        state.isLoadZnsEvent = false;
        state.error = action.payload;
      });
  },
});

export const { setCurrentPage, setPageSize, setTotalRecords } = znsEventSlice.actions;
export default znsEventSlice.reducer;
